// This is the central module registration file
// Please add the module index, the store and the module id of a new module to make it work.
import news from './news';
import gallery from './gallery';
import forms from './forms';
import video from './video';
import documents from './document';
import fahrdienst from './fahrdienst';
import fahrplan from './fahrplan';
import fahrdienst452 from './fahrdienst452';
import myDuties from './myDuties';
import unfalldesk from './unfalldesk';
import vbzWorksheet from './customerVbzWorksheet';
import messaging from './messaging';
import wagenbuch from './wagenbuch';
import weblinks from './weblinks';
import elearning from './elearning';
import telemetrie from './telemetrie';
import employee from './employee';
import media from './media';
import begleitfahrt from './begleitfahrt';
//
import documentsStore from './document/store';
import newsStore from './news/store';
import formsStore from './forms/store';
import galleryStore from './gallery/store';
import videoStore from './video/store';
import fahrdienstStore from './fahrdienst/store.js';
import fahrplanStore from './fahrplan/store.js';
import fahrdienst452Store from './fahrdienst452/store';
import myDutiesStore from './myDuties/myDutyStore';
import unfalldeskStore from './unfalldesk/store';
import vbzWorksheetStore from './customerVbzWorksheet/store';
import wagenbuchStore from './wagenbuch/store';
import weblinkStore from './weblinks/store';
import messagingStore from './messaging/store';
import elearningStore from './elearning/store';
import mediaStore from './media/store.js';

import telemetrieStore from './telemetrie/store';
import employeeStore from './employee/store';
import begleitfahrtStore from './begleitfahrt/store';
//
import DOCUMENT_ID from './document/moduleId';
import NEWS_ID from './news/moduleId';
import FORMS_ID from './forms/moduleId';
import GALLERY_ID from './gallery/moduleId';
import FAHRDIENST_ID from './fahrdienst/moduleId';
import FAHRPLAN_ID from './fahrplan/moduleId';
import FAHRDIENST452_ID from './fahrdienst452/moduleId';
import MY_DUTIES_ID from './myDuties/moduleId';
import UNFALLDESK_ID from './unfalldesk/moduleId';
import CUSTOMER_VBZ_WORKSHEET_ID from './customerVbzWorksheet/moduleId';
import WAGENBUCH_ID from './wagenbuch/moduleId';
import WEBLINKS_ID from './weblinks/moduleId';
import MESSAGING_ID from './messaging/moduleId';
import ELEARNING_ID from './elearning/moduleId';
import MEDIA_ID from './media/moduleId';
import TELEMETRIE_ID from './telemetrie/moduleId';
import EMPLOYEE_ID from './employee/moduleId';
import BEGLEITFAHRT_ID from './begleitfahrt/moduleId';

const VIDEO_ID = video.moduleId;
// console.debug('--------------VIDEO_ID', VIDEO_ID);
// ADD any new module here
const MODULE_INDICES = [
  employee,
  forms,
  news,
  gallery,
  video,
  documents,
  fahrdienst,
  fahrplan,
  fahrdienst452,
  myDuties,
  messaging,
  unfalldesk,
  vbzWorksheet,
  wagenbuch,
  weblinks,
  elearning,
  media,
  telemetrie,
  begleitfahrt,
];

// Stores get exported and saved at the module id path.
// Stores need to be exported separately from moduleIndex objects since we have dependency cycles.
// ADD new module here and
const stores = {};
stores[DOCUMENT_ID] = documentsStore;
stores[FORMS_ID] = formsStore;
stores[NEWS_ID] = newsStore;
stores[VIDEO_ID] = videoStore;
stores[GALLERY_ID] = galleryStore;
stores[FAHRDIENST_ID] = fahrdienstStore;
stores[FAHRPLAN_ID] = fahrplanStore;
stores[FAHRDIENST452_ID] = fahrdienst452Store;
stores[MY_DUTIES_ID] = myDutiesStore;
stores[UNFALLDESK_ID] = unfalldeskStore;
stores[CUSTOMER_VBZ_WORKSHEET_ID] = vbzWorksheetStore;
stores[MESSAGING_ID] = messagingStore;
stores[WAGENBUCH_ID] = wagenbuchStore;
stores[WEBLINKS_ID] = weblinkStore;
stores[ELEARNING_ID] = elearningStore;
stores[MEDIA_ID] = mediaStore;
stores[TELEMETRIE_ID] = telemetrieStore;
stores[EMPLOYEE_ID] = employeeStore;
stores[BEGLEITFAHRT_ID] = begleitfahrtStore;

// Modules index. Only place with access to modules.
class Modules {
  constructor() {
    this.MODULES_BY_MODULE_TYPE = {};
    MODULE_INDICES.forEach((moduleIndex) => {
      //console.debug(`Module Index for ${moduleIndex.moduleType}`, moduleIndex);
      if (moduleIndex) this.MODULES_BY_MODULE_TYPE[moduleIndex.moduleType] = moduleIndex;
    });

    this.MODULES_BY_ID = {};
    MODULE_INDICES.forEach((moduleIndex) => {
      if (moduleIndex) this.MODULES_BY_ID[moduleIndex.moduleId] = moduleIndex;
    });
    this.initialized = true;

    // console.debug('MODULES_BY_MODULE_TYPE', JSON.stringify(this.MODULES_BY_MODULE_TYPE, null, 2));
  }

  /**
   * Gets the module index from the module type (used in module config type property. Example type:"MeinDienst")
   * @param {*} moduleType Module type as referenced in module config
   * @returns module index or undefined if not implemented
   */
  getModuleIndexFromModuleType(moduleType) {
    return this.MODULES_BY_MODULE_TYPE[moduleType];
  }

  isModuleImplemented(moduleType) {
    return this.MODULES_BY_MODULE_TYPE[moduleType] !== undefined;
  }

  getModuleById(moduleId) {
    return this.MODULES_BY_ID[moduleId];
  }

  getImplementedModuleIndex(moduleType) {
    return this.MODULES_BY_MODULE_TYPE[moduleType];
  }

  getModuleHandler(moduleType) {
    // if (this.MODULES_BY_MODULE_TYPE[moduleType]) {
    //   console.debug('routeHandler for ', moduleType, this.MODULES_BY_MODULE_TYPE[moduleType].routeHandler);
    // }
    return this.MODULES_BY_MODULE_TYPE[moduleType] ? this.MODULES_BY_MODULE_TYPE[moduleType].routeHandler : null;
  }
}

export default new Modules();

export { stores };
